import { Badge, Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useFilterHeaderStyles } from "./filterHeaderStyles"
import { useTranslation } from "react-i18next"
import { FilterHeaderDetailProps } from "./types"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import BaseModal from "../../../../../../components/modal/baseModal"
import { useDimensions } from "../../../../../../hooks/dimensions"

const FilterHeaderTemplate = ({ filter, modal, title, input, hiddenRefresh, filterButton, refresh, closeFiltersModal, openModal, cleanFilter }: FilterHeaderDetailProps) => {
    const styles = useFilterHeaderStyles()
    const { t } = useTranslation()
    const { dimensions } = useDimensions()
    return (
        <>
            <Box sx={styles.containerIcons}>
                {!!filter.counter &&
                    <Button
                        onClick={() => {
                            cleanFilter()
                        }}
                        variant="text"
                        sx={[styles.footerText, styles.cleanText]}
                    >
                        {t('general.cleanFilters')}
                    </Button>
                }
                <Badge sx={styles.badge({})} badgeContent={filter.counter}>
                    <Tooltip title={t('ToolTips.filters')}>
                        <IconButton
                            sx={styles.filter}
                            onClick={() => {
                                openModal()
                            }}
                        >
                            {icons('filter')}
                        </IconButton>
                    </Tooltip>
                </Badge>
                {!hiddenRefresh && (
                    <IconButton
                        sx={styles.refresh}
                        onClick={() => {
                            refresh()
                        }}
                    >
                        {icons("refresh")}
                    </IconButton>
                )}
            </Box>

            <BaseModal sx={{ borderRadius: '0px' }} modalProps={{ sx: { '& .custome-modal-container': { maxHeight: dimensions.height < 650 ? '90vh' : '600px', paddingBottom: '0' } } }} open={modal.open}>
                <Box sx={styles.containerModal}>
                    <Box sx={styles.headerModal}>
                        <Typography sx={styles.headerModalTitle}>{title}</Typography>
                    </Box>

                    <IconButton onClick={() => { closeFiltersModal() }} sx={styles.close}>{icons('simple-close')}</IconButton>

                    <DinamicForm
                        legacyErrors
                        errors={filter.errors}
                        input={Object.values(input)}
                        values={filter.filterData}
                        onChange={filter.onChange}
                    />

                    <Button
                        variant="contained"
                        onClick={() => {
                            filterButton()
                        }}
                        sx={styles.btnFilter}>
                        {t('general.filter')}
                    </Button>
                </Box>
            </BaseModal>
        </>
    )
}

export { FilterHeaderTemplate }
